import React, { useState } from 'react';
import { BiInfoCircle, BiPlus, BiTrash } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';
import Bouton from '../../UI/Bouton/Bouton';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from './SelectInput.module.scss';

const SelectInput = ({ argument, onChange }) => {
  const [nouvelleOption, setNouvelleOption] = useState({
    value: '',
    label: '',
  });

  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  const ajouterOption = () => {
    if (!nouvelleOption.value.trim() || !nouvelleOption.label.trim()) return;

    const optionsExistantes = argument.options?.optionsList || [];
    const nouvellesOptions = [...optionsExistantes, { ...nouvelleOption }];

    handleOptionChange('optionsList', nouvellesOptions);
    setNouvelleOption({ value: '', label: '' });
  };

  const supprimerOption = (index) => {
    const optionsExistantes = argument.options?.optionsList || [];
    const nouvellesOptions = optionsExistantes.filter((_, i) => i !== index);
    handleOptionChange('optionsList', nouvellesOptions);
  };

  return (
    <div className={S.selectContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet de choisir une valeur parmi une liste
          prédéfinie.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            value={argument.description || ''}
            onChange={(value) => onChange('description', value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Valeur par défaut</label>
          <ChampDeTexte
            value={argument.valeurParDefaut || ''}
            onChange={(value) => onChange('valeurParDefaut', value)}
            placeholder="Valeur par défaut (optionnel)"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            onChange={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options de sélection</h6>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.allowEmpty !== false}
            onChange={(checked) => handleOptionChange('allowEmpty', checked)}
            label="Permettre une sélection vide"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Texte pour option vide</label>
          <ChampDeTexte
            value={argument.options?.emptyText || ''}
            onChange={(value) => handleOptionChange('emptyText', value)}
            placeholder="-- Sélectionner --"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Liste des options</label>

          {/* Existing options */}
          <div className={S.optionsList}>
            {(argument.options?.optionsList || []).map((option, index) => (
              <div key={index} className={S.optionItem}>
                <div className={S.optionText}>
                  <strong>{option.label}</strong> ({option.value})
                </div>
                <button
                  className={S.removeButton}
                  onClick={() => supprimerOption(index)}
                  type="button"
                >
                  <BiTrash size={14} />
                </button>
              </div>
            ))}
          </div>

          {/* Add new option */}
          <div className={S.addOptionContainer}>
            <div className={S.addOptionInput}>
              <label className={S.label}>Valeur</label>
              <ChampDeTexte
                value={nouvelleOption.value}
                onChange={(value) =>
                  setNouvelleOption((prev) => ({
                    ...prev,
                    value: value,
                  }))
                }
                placeholder="valeur_technique"
              />
            </div>
            <div className={S.addOptionInput}>
              <label className={S.label}>Libellé</label>
              <ChampDeTexte
                value={nouvelleOption.label}
                onChange={(value) =>
                  setNouvelleOption((prev) => ({
                    ...prev,
                    label: value,
                  }))
                }
                placeholder="Libellé affiché"
              />
            </div>
            <Bouton
              type={type_btn.success}
              cliquer={ajouterOption}
              taille="small"
              disabled={
                !nouvelleOption.value.trim() || !nouvelleOption.label.trim()
              }
            >
              <BiPlus size={14} />
            </Bouton>
          </div>
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Liste déroulante
              <div className={S.mockOptions}>
                {argument.options?.allowEmpty !== false && (
                  <div className={S.mockOption}>
                    {argument.options?.emptyText || '-- Sélectionner --'}
                  </div>
                )}
                {(argument.options?.optionsList || []).map((option, index) => (
                  <div key={index} className={S.mockOption}>
                    {option.label}
                  </div>
                ))}
              </div>
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectInput;
